import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
    options: {
        customProperties: true
    },
    theme: {
        themes: {
            light: {
                primary: '#004777',
                secondary: '#1d65a2',
                accent: '#F8A25D',
                error: '#f33333',
                info: '#00bcd4',
                success: '#8bc34a',
                warning: '#ef562d',
                content: '#f70b0b'
            },
        },
    },
    lang: {
        locales: {
            fr
        },
        current: 'fr',
    },
    icons: {
        iconfont: 'fa'
    }
});